/**
 * List of options for the Impinj RFID Reader "Reader Mode" field
 *
 * @namespace tmrRfidReaderImpinjReaderModes
 * @type {ngConstant}
 */
export const constant = [
  'tmrRfidReaderImpinjReaderModes',
  {
    AUTO_SET_DENSE_READER: 'IMPINJ.READERMODES.AUTO_SET_DENSE_READER',
    AUTO_SET_DENSE_READER_DEEP_SCAN:
      'IMPINJ.READERMODES.AUTO_SET_DENSE_READER_DEEP_SCAN',
    DENSE_READER_M4: 'IMPINJ.READERMODES.DENSE_READER_M4',
    DENSE_READER_M4_TWO: 'IMPINJ.READERMODES.DENSE_READER_M4_TWO',
    DENSE_READER_M8: 'IMPINJ.READERMODES.DENSE_READER_M8',
    HYBRID: 'IMPINJ.READERMODES.HYBRID',
    MAX_MILLER: 'IMPINJ.READERMODES.MAX_MILLER',
    MAX_THROUGHPUT: 'IMPINJ.READERMODES.MAX_THROUGHPUT',
  },
]

/**
 * Translates {@link tmrRfidReaderImpinjReaderModes}
 *
 * @type {ngRun}
 */
let tmrRfidReaderImpinjReaderModesRun = /*@ngInject*/ (
  TmrTranslate,
  tmrRfidReaderImpinjReaderModes
) => TmrTranslate.object(tmrRfidReaderImpinjReaderModes)

export { tmrRfidReaderImpinjReaderModesRun as run }
